/* eslint-disable */
import React, { useRef, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import login from '../img/create-account.png'
import { useTheme } from '../context/ThemeProvider'
import { Link } from 'react-router-dom'

import axios from '../api/axios'
import useAuth from '../hooks/useAuth'

const EMAIL_REGEX =
  /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,12})$/
const FORGOT_PWD_URL = '/forgot-password'

const FindOrg = () => {
  const theme = useTheme()
  const errRef = useRef()
  const navigate = useNavigate()
  const inputRef = useRef()
  const logo = theme?.logo
  const { orgDetails, setOrgDetails } = useAuth()

  const [reference, setReference] = useState('')
  const [confirmed, setConfirmed] = useState(false)

  const [email, setEmail] = useState('')
  const [validEmail, setValidEmail] = useState(false)

  const [errMsg, setErrMsg] = useState('')
  const hoverText = theme?.brand === 'swb' ? 'hover:text-violet-400' : 'hover:text-portal-medium'
  useEffect(() => {
    const result = EMAIL_REGEX.test(email)
    setValidEmail(result)
  }, [email])

  useEffect(() => {
    setErrMsg('')
  }, [email])

  useEffect(() => {
    inputRef.current.focus()
  }, [])

  useEffect(() => {
    // If user refreshes and has orgDetails, clear them to start fresh
    if (orgDetails && !confirmed) {
      setOrgDetails(null)
    }
  }, [])

  const handleFindOrg = async (e) => {
    e.preventDefault()
    if (!reference.trim()) return setErrMsg('Please enter a reference.')

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_KIS_BASE_URL}/api/v2/validate-token`,
        {
          token: reference,
        }
      )

      const data = res.data

      if (!data.valid) {
        setErrMsg('Invalid organisation reference.')
        setOrgDetails(null)
        return
      }
      setOrgDetails({
        name: data.entity_name || 'Unknown organisation',
        postcode: data.entity_postcode || '',
        orgId: data.entity_id || '',
        valid: data.valid || false,
        trust_id: data.trust_id || null,
        trust_name: data.trust_name || null,
        trust_urn: data.trust_urn || null,
      })

      setErrMsg('')
    } catch (error) {
      setErrMsg('No organisation found with that reference.')
      setOrgDetails(null)
    }
  }

  const handleConfirm = () => {
    // Ensure org details are set in context before navigation
    setOrgDetails({
      name: orgDetails.name,
      postcode: orgDetails.postcode,
      orgId: orgDetails.orgId,
      trust_id: orgDetails.trust_id || null,
      trust_name: orgDetails.trust_name || null,
      trust_urn: orgDetails.trust_urn || null,
    })
    navigate('/create-account/step-2', { state: { ...orgDetails } })
  }

  return (
    <div
      className="min-h-screen bg-cover bg-center px-8 relative"
      style={{ backgroundImage: `url(${login})` }}
    >
      <div className="max-w-lg w-full space-y-4 md:space-y-6 py-8 px-4 md:absolute md:top-[15%] md:left-[15%]">
        <div className="pt-16 md:pt-0 flex items-center gap-3 pb-2 leading-tight tracking-wider text-[#360F41] dark:text-white">
          <img src={logo} alt="SWB Logo" className="h-20 w-auto" />
          <div>
            {theme.brand === 'swb' ? (<h1 className="text-2xl md:text-3xl font-bold">
              School Wellbeing <br /> Staff Portal
            </h1>) : (
              <h1 className="text-2xl md:text-3xl font-bold">
              Be Well Support <br /> Staff Portal
            </h1>
            )}
            <h2 className="text-sm md:text-base font-medium">
              Find your Organisation
            </h2>
          </div>
        </div>

        <p
          ref={errRef}
          className={errMsg ? 'errmsg text-red-600 text-sm' : 'offscreen'}
          aria-live="assertive"
        >
          {errMsg}
        </p>

        <form
          onSubmit={orgDetails && confirmed ? handleConfirm : handleFindOrg}
          className="space-y-4"
        >
          <div>
            <label
              htmlFor="org"
              className="block mb-2 text-sm font-medium text-gray-700"
            >
              Organisation Reference
            </label>
            <input
              type="text"
              ref={inputRef}
              id="org"
              value={reference}
              onChange={(e) => setReference(e.target.value)}
              required
              placeholder="Enter reference"
              disabled={confirmed}
              className={`bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:outline-none block w-full p-2.5 
                dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white
                ${
                  theme?.brand === 'swb'
                    ? 'focus:border-violet-300 focus:ring-1 focus:ring-violet-300'
                    : 'focus:border-hub-primary-light focus:ring-1 focus:ring-hub-primary-light'
                }`}
            />
          </div>

          {orgDetails && !confirmed && (
            <div className="bg-violet-50 border border-violet-300 rounded p-4 text-sm text-[#360F41]">
              <p className="font-semibold">Organisation Found:</p>
              <p>{orgDetails.name}</p>
              <p className="text-gray-600">{orgDetails.postcode}</p>
              <button
                type="button"
                onClick={() => handleConfirm()}
                className="mt-3 bg-portal-light hover:bg-portal-medium text-white py-1 px-4 rounded-lg"
              >
                Confirm
              </button>
            </div>
          )}

          {orgDetails ? (
            <button
              type="button"
              onClick={() => {
                setOrgDetails(null)
                setConfirmed(false)
                setReference('')
                inputRef.current.focus()
              }}
              className="w-full bg-portal-light hover:bg-portal-medium text-white font-semibold py-2 px-4 rounded-lg transition"
            >
              Not your Organisation? Try Again
            </button>
          ) : (
            <button
              type="submit"
              className="w-full bg-portal-light hover:bg-portal-medium text-white font-semibold py-2 px-4 rounded-lg transition"
            >
              Find Organisation
            </button>
          )}
          <div className="mt-6 text-xs text-gray-500 font-medium">
            <Link to="/login" className={hoverText}>
              Already have an account? Log in here
            </Link>
          </div>
        </form>
      </div>
    </div>
  )
}

export default FindOrg